import PubSub from "underpub-js";
import Swiper from 'swiper';
import { Navigation } from 'swiper/modules';
Swiper.use([Navigation]);

var ListingIconInfo = function (options) {

	this.options = {
		$el: false,
		baseClass: 'mol-ListingIconInfo',
	};

	$.extend(true, this.options, options);

};

ListingIconInfo.prototype.init = function () {

	var self = this;
	// self.centerSlides = self.options.$el.attr("data-center-slides") == "true";
	// self.numberOfSlides = parseInt(self.options.$el.attr("data-number-of-slides"));
	// self.$slides = self.options.$el.find(`.${self.options.baseClass}__items`);
	// self.$arrowPrev = self.options.$el.find(`.${self.options.baseClass}__arrow--prev`);
	// self.$arrowNext = self.options.$el.find(`.${self.options.baseClass}__arrow--next`);

	// self.initCarousel();
};
// console.log(self.centerSlides );
// console.log(self.numberOfSlides);
ListingIconInfo.prototype.initCarousel = function () {

	var self = this;

	let swiperOptions = {
		loop: true,
		slidesPerView: 1,
		spaceBetween: "32px",
		mousewheel: {
			enabled: true,
			forceToAxis: true,
		},

		// arrows
		navigation: {
			nextEl: self.$arrowNext[0],
			prevEl: self.$arrowPrev[0],
		},

		breakpoints: {
			560: {
				slidesPerView: 1,
			},
			768: {
				slidesPerView: 2,
			},
			1024: {
				slidesPerView: 2.5,
			},
			1280: {
				slidesPerView: 3.1,
			}
		}

	};


	self.swiper = new Swiper(self.$slides[0], swiperOptions);

};
export default ListingIconInfo;
